<template>
  <div>
    <h1>{{$t('financial.global.sales')}}</h1>
    <b-row>
      <b-col>
        <router-link :to="'./create/'">
          <b-button size="sm">{{ $t("geral.create") }}</b-button>
        </router-link>
      </b-col>
    </b-row>

    <b-row style="min-height: 500px; flex-grow: 1;">
      <b-col class="ag-theme-alpine-dark">
        <ag-grid-vue
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :defaultColDef="defaultColDef"
          :domLayout="'autoHeight'"
          :pagination="true"
          rowHeight="40"
          :paginationPageSize="15"
          @rowClicked="onRowClicked"
        ></ag-grid-vue>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      gridOptions: {
        onGridReady: this.onGridReady,
        paginationPageSize: 15
      },
      columnDefs: [
        { headerName: "Cód.", field: "code", sortable: false, filter: true },
        {
          headerName: "Status",
          field: "status",
          sortable: false,
          filter: true
        },
        {
          headerName: "Cliente",
          field: "client",
          sortable: false,
          filter: true,
          valueGetter: params => params.data.client?.code || ""
        },
        {
          headerName: "Vendedor",
          field: "seller",
          sortable: false,
          filter: true,
          valueGetter: params => params.data.seller?.code || ""
        },
        {
          headerName: "Data criação",
          field: "dates",
          sortable: false,
          filter: true,
          valueGetter: params => params.data.dates?.estimateDate || ""
        },
        {
          headerName: "Valor Final",
          field: "total",
          sortable: false,
          filter: true,
          valueGetter: params => params.data.total.finalTotal || 0
        },
        {
          headerName: "Data Vencimento",
          field: "dates",
          sortable: false,
          filter: true,
          valueGetter: params => params.data.dates?.validity || ""
        }
      ],
      rowData: [
        {
          code: "001",
          status: "",
          client: { id: "", code: "" },
          seller: { id: "", code: "" },
          dates: {
            estimateDate: "2025-02-07",
            validity: "07/03/2025",
            forecast: "07/06/2025"
          },
          notes: "TESTE",
          items: [
            {
              productOrService: "",
              quantity: 5,
              unitPrice: 15,
              totalPrice: 75,
              itemNotes: ""
            }
          ],
          discount: {
            value: 0,
            type: "valor"
          },
          total: {
            itemsTotal: 0,
            discountValue: 0,
            finalTotal: 0
          },
          paymentNotes: ""
        }
      ],
      defaultColDef: {
        resizable: true,
        flex: 1
      }
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    onRowClicked(event) {
      const rowData = event.data;
      this.$router.push({
        name: "SaleCrud",
      });
    }
  }
};
</script>

<style>
.ag-theme-alpine-dark .ag-root {
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-header,
.ag-theme-alpine-dark .ag-header-cell-label {
  background-color: #1e1e2f;
  color: #ffffffb3 !important;
  font-family: "Poppins";
  font-size: 12px;
}
.ag-theme-alpine-dark {
  border: none !important;
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-root-wrapper {
  background-color: #1e1e2f;
  border: none !important;
}
.ag-theme-alpine-dark .ag-row {
  background-color: #1e1e2f !important;
}
</style>
